import MaskUtil from "common/util/MaskUtil";

export default function() {

	window.ObserverUtil.observe('buy1click2-form', () => {

		$('.buy1click2-form__content').append($('.buy1click2-form__policy'));

		$('.buy1click2-form__comment-input').addClass('buy1click2-form-field__input');
		$('.buy1click2-form__coupon').addClass('buy1click2-form-field__input');

		$('.buy1click2-form-field__label').each(function(){
			const label = $(this);
			label.after(`<div class="buy1click2-form-field__placeholder">${label.html()}</div>`);
		});

		MaskUtil.initIntlTelMask($('.buy1click2-form-field__input[type="tel"]'));

		$('.buy1click2-form-field__input').on('focus', function(){
			$(this).closest('.buy1click2-form-field').addClass('buy1click2-form-field_focused');
		}).on('blur', function(){
			$(this).closest('.buy1click2-form-field').removeClass('buy1click2-form-field_focused');
		});

		$('.buy1click2-form-field__input').each(function(){
			if ($(this).val()) {
				$(this).closest('.buy1click2-form-field').addClass('buy1click2-form-field_hasvalue');
			}
		});

		$('.buy1click2-form-field__input').on('input', function(){
			const input = $(this);
			const wrapper = input.closest('.buy1click2-form-field');
			wrapper.removeClass('buy1click2-form-field_error');
			if (input.val()) {
				wrapper.addClass('buy1click2-form-field_hasvalue');
			} else {
				wrapper.removeClass('buy1click2-form-field_hasvalue');
			}
		});

	})
}
